import * as React from "react";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import {
    DrawdownType,
    DrawdownType as DrawdownTypeEnum,
} from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { PensionProtectionDetails } from "../../../../../../../Wrap/Models/Models/Customer/PensionProtection/PensionProtectionDetails";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { DrawdownTypeOptionsMap } from "./Resource/Contents";
import { ProcessType } from "../../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { CustomerPensionProtectionModel } from "../../../../../../../Wrap/Models/Domains/Drawdown/CustomerPensionProtectionModel";
import { SectionHeader } from "../../SharedComponents";

interface IDrawdownTypeProps extends IProcessComponentProps {
    pensionProtection: CustomerPensionProtectionModel;
    originType: DrawdownType;
    isImmediateTaxFreeLumpSum: boolean;
    activityType: ProcessType;
    hasExistingOnPlatformCappedDrawdown?: boolean;
    PersonalRecommendation: boolean;
    canCreateRegularCrystallisation?: boolean;
}

interface IDrawdownTypeState {
    showDetail: boolean;
}

export class DrawdownTypeOption extends ProcessComponent<IDrawdownTypeProps, IDrawdownTypeState> {
    constructor(props: any) {
        super(props);
        this.state = { showDetail: false };
    }

    componentDidMount(): void {
        super.componentDidMount();
        const drawdownTypeOptions = this.getDrawdownTypeOptions();
        if (drawdownTypeOptions.length == 1 && this.props.isImmediateTaxFreeLumpSum) {
            this.changeDrawdownType(drawdownTypeOptions[0]);
        }
    }

    private getDrawdownTypeOptions(): DrawdownTypeEnum[] {
        const {
            data,
            pensionProtection,
            isImmediateTaxFreeLumpSum,
            activityType,
            hasExistingOnPlatformCappedDrawdown,
            PersonalRecommendation
        } = this.props;

        let canCreateRegularCrystallisation = true;
        if (this.props.canCreateRegularCrystallisation != null)
        {
            canCreateRegularCrystallisation = this.props.canCreateRegularCrystallisation;
        }

        const options = [DrawdownTypeEnum.Flexible];
        if (
            !pensionProtection?.Primary?.HasProtection &&
            !pensionProtection?.PensionSchemeSpecificProtection?.HasProtection &&
            !isImmediateTaxFreeLumpSum &&
            PersonalRecommendation &&
            canCreateRegularCrystallisation
        ) {
            options.push(DrawdownTypeEnum.Regular);
        }
        if (
            isImmediateTaxFreeLumpSum &&
            activityType != ProcessType.NewBusiness &&
            activityType != ProcessType.Quote &&
            hasExistingOnPlatformCappedDrawdown
        ) {
            options.push(DrawdownTypeEnum.Capped);

            if (data != null) {
                data.DrawdownType = DrawdownTypeEnum.Capped;
            }
        }
        return options;
    }

    private isDisabled(): boolean {
        const { isImmediateTaxFreeLumpSum } = this.props;
        return isImmediateTaxFreeLumpSum && this.getDrawdownTypeOptions().length == 1;
    }

    private changeDrawdownType = (drawdownType: DrawdownType) => {
        const { originType, onChange} = this.props;
        const originIsRegular = originType == DrawdownType.Regular;
        const currIsRegular = drawdownType == DrawdownType.Regular;
        const hasChanged = originIsRegular != currIsRegular
        onChange({ DrawdownType: drawdownType, ChangeInstructionType: hasChanged });
    }

    public render(): JSX.Element {
        const { data } = this.props;

        return (
            <>
                {SectionHeader("Drawdown type")}
                <SelectEditor
                    placeholder={"Please select"}
                    cssWrapper="control-size-300"
                    getText={(v) => {
                        return DrawdownTypeOptionsMap[v];
                    }}
                    label="Select type"                                                     
                    options={this.getDrawdownTypeOptions()}
                    onChange={ this.changeDrawdownType}
                    selected={data?.DrawdownType}
                    required="Please select a drawdown type"
                    disabled={this.isDisabled()}
                />
                <hr className="mb-20" />
            </>
        );
    }
}
